
    import './styles.scoped.css';
    export default {
  "breadcrumb-item": "awsui_breadcrumb-item_1c68o_b6unx_5"
};
  